import appApi from '../../../../../../api/app-api';
import { toast } from 'react-toastify';
import { SelectedSlotsState } from '../../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import globalCourseStore from '../../../../../../stores/global-course-store';
import globalConfigStore from '../../../../../../stores/global-config-store';
import globalCourseCalendarStore from '../../../../../../stores/global-course-calendar';
import { SerialLecturesRequest } from '../../../../../../api/types/calender/serial/serial-lectures-request';
import {
  ApiErrorCodes,
  displayErrorText,
} from '../../../../../../api/errors/api-error-codes';

export const createSerialLecturesOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  lecturesWithActivityTypeData: {
    lecturerId: number;
    activityTypeId: number | undefined;
  }[],
  selectedSlots: SelectedSlotsState,
  setLoading: (isLoading: boolean) => any,
  onHide: () => any,
  attendanceRequired: boolean,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn('לא ניתן לאתר את פרטי התוכנית ו/או הקורס');
      return;
    }

    if (
      lecturesWithActivityTypeData.length === 0 ||
      lecturesWithActivityTypeData.some((item) => !item.activityTypeId)
    ) {
      toast.warn('יש לבחור מרצים וסוג פעילות');
    }
    const lecturesWithActivityType = lecturesWithActivityTypeData as {
      lecturerId: number;
      activityTypeId: number;
    }[];

    const transformSelectedSlots = (
      selectedSlots: SelectedSlotsState,
    ): Array<{ startTime: Date; endTime: Date; classId: number }> => {
      // Flatten all selected slots from all lectures into a single array
      return Object.values(selectedSlots)
        .flat()
        .map((slot) => ({
          startTime: slot.startTime,
          endTime: slot.endTime,
          classId: slot.classId,
        }));
    };
    const serial = transformSelectedSlots(selectedSlots);

    const asd: SerialLecturesRequest = {
      serial: serial,
      lecturersWithActivityTypeIds: lecturesWithActivityType,
    };

    setLoading(true);

    const createSerialLectureRes = await appApi.createNewSerialLectures(
      programId,
      courseId,
      asd,
      attendanceRequired,
    );
    const courseDetails = await appApi.getCourseDetails(programId, courseId);
    globalCourseStore.fetchCourseDetails(programId, courseId);

    if (createSerialLectureRes.data.errCode) {
      toast.info(displayErrorText(createSerialLectureRes.data.errCode));
      setLoading(false);
      return;
    }

    /*if (
      createSerialLectureRes.data.errCode ===
      ApiErrorCodes.NOT_VALID_RATE_REQUIREMENT
    ) {
      toast.warn(`לא נמצא תעריף מתאים לנתונים המבוקשים`);
      setLoading(false);
      return;
    }*/
    // Update lecturer state
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse?.details?.lectures) {
      currentCourse.details.lectures = createSerialLectureRes.data.body;
    }

    // Update calendar state
    const branch = globalConfigStore.rootFilter.currentBranches;
    if (branch) {
      await globalCourseCalendarStore.loadCalendarEvents(
        branch.id,
        new Date(selectedSlots[0][0].startTime).getFullYear(),
        new Date(selectedSlots[0][0].endTime).getMonth() + 1,
      );
    }

    setLoading(false);
    onHide();
  } catch (e) {
    console.error(
      `createSerialLecturesOperations is failed with the programId: ${programId}, courseId: ${courseId}, lecturesWithActivityTypeData: ${lecturesWithActivityTypeData}, selectedSlots: ${selectedSlots}`,
    );
    setLoading(false);
  }
};
